import React from "react";

const Input = ({
  type = "text",
  id,
  name,
  placeholder,
  defaultValue,
  value,
  onChange,
  className = "",
  min,
  max,
  step,
  disabled = false,
  readOnly = false,
  success = false,
  error = false,
  hint,
  onBlur,
  onKeyDown,
  autoFocus = false,
}) => {
  // Determine input styles based on state (disabled, success, error)
  let inputClasses = `h-10 w-full rounded-lg border appearance-none px-3.5 py-2 text-sm shadow-theme-xs placeholder:text-gray-400 dark:placeholder:text-gray-600 focus:outline-hidden focus:ring-4 bg-white text-gray-800 border-gray-300 focus:border-gray-400 focus:ring-gray-200 dark:bg-gray-950 dark:text-white/90 dark:border-gray-800 dark:focus:border-white dark:focus:ring-white/10 ${className}`;

  // Add styles for the different states
  if (disabled) {
    inputClasses += ` text-gray-500 border-gray-200 cursor-not-allowed bg-gray-100 opacity-70 dark:text-gray-600 dark:border-gray-800 dark:bg-gray-900`;
  } else if (readOnly) {
    inputClasses += ` cursor-default bg-gray-50 dark:bg-gray-950/80`;
  } else if (error) {
    inputClasses += ` text-error-400 border-error-500/50 focus:ring-error-500/10 focus:border-error-500`;
  } else if (success) {
    inputClasses += ` text-success-400 border-success-500/50 focus:ring-success-500/10 focus:border-success-500`;
  }

  return (
    <div className="relative">
      <input
        type={type}
        id={id}
        name={name}
        autoFocus={autoFocus}
        placeholder={placeholder}
        {...(value !== undefined
          ? readOnly
            ? { value }
            : { value, onChange }
          : { defaultValue, onChange })}
        min={min}
        max={max}
        step={step}
        disabled={disabled}
        readOnly={readOnly}
        {...(onBlur != null ? { onBlur } : {})}
        {...(onKeyDown != null ? { onKeyDown } : {})}
        className={inputClasses}
      />

      {/* Optional Hint Text */}
      {hint && (
        <p
          className={`mt-1 text-[10px] ${
            error
              ? "text-error-500"
              : success
              ? "text-success-500"
              : "text-gray-500"
          }`}
        >
          {hint}
        </p>
      )}
    </div>
  );
};

export default Input;
